import axios from '../utils/axios'

// 获取搜索列表数据
export function firstCategoryLeve () {
  return axios({
    url: '/NoAuth/Product/GetCategoryLeve1',
    methods: 'get'
  })
}
export function secondCategoryLeve (query) {
  return axios({
    url: '/NoAuth/Product/GetCategoryLeve2',
    method: 'get',
    params: query
  })
}
